import LESSON_TYPES from "../types/lessonTypes";

const initialState = {
  loading: false,
  submitting: false,
  lessonData: null,
  error: null,
};

export default function lessonReducer(state = initialState, action) {
  switch (action.type) {
    case LESSON_TYPES.FETCH_LESSON_DETAILS_BEGIN:
      return {
        ...state,
        lessonData: null,
        loading: true,
        error: null,
      };

    case LESSON_TYPES.FETCH_LESSON_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        lessonData: action.payload.data,
      };

    case LESSON_TYPES.FETCH_LESSON_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case LESSON_TYPES.MARK_LESSON_COMPLETE_BEGIN:
      return {
        ...state,
        submitting: true,
        error: null,
      };

    case LESSON_TYPES.MARK_LESSON_COMPLETE_SUCCESS:
      return {
        ...state,
        submitting: false,
      };

    case LESSON_TYPES.MARK_LESSON_COMPLETE_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case LESSON_TYPES.MARK_LESSON_INCOMPLETE_BEGIN:
      return {
        ...state,
        submitting: true,
        error: null,
      };

    case LESSON_TYPES.MARK_LESSON_INCOMPLETE_SUCCESS:
      return {
        ...state,
        submitting: false,
      };

    case LESSON_TYPES.MARK_LESSON_INCOMPLETE_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case LESSON_TYPES.ADD_LESSON_TO_CLASSROOM_BEGIN:
      return {
        ...state,
        submitting: true,
        error: null,
      };

    case LESSON_TYPES.ADD_LESSON_TO_CLASSROOM_SUCCESS:
      return {
        ...state,
        submitting: false,
      };

    case LESSON_TYPES.ADD_LESSON_TO_CLASSROOM_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
